<button
  (click)="talkMeService.openLiveChat()"
  class="livechat"
  type="button"
  placement="left"
  ngbTooltip="Написать в чат"
  tooltipClass="custom-tooltip"
  data-analytics="write_message"
>
  <cx-icon [type]="iconType.CHAT"></cx-icon>
  <span class="label">Написать в чат</span>
</button>
